import React from 'react';
import authRoles from '../../../auth/authRoles';
import SchoolAdmin from './SchoolAdmin';
import AddSchoolAdmin from './addSchoolAdmin/AddSchoolAdmin';
import ViewSchoolAdmin from './viewSchoolAdmin/ViewSchoolAdmin';
import EditSchoolAdmin from './editSchoolAdmin/EditSchoolAdmin';

const SchoolAdminConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/subadmin',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SchoolAdmin />
				</React.Suspense>
			),
		},
		{
			path: '/subadmin-AddSchoolAdminProfile',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddSchoolAdmin />
				</React.Suspense>
			),
		},
		{
			path: '/subadmin-ViewSchoolAdminProfile/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ViewSchoolAdmin />
				</React.Suspense>
			),
		},
		{
			path: '/subadmin-EditSchoolAdminProfile/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditSchoolAdmin />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default SchoolAdminConfig;
